module.exports = __webpack_public_path__ + "media/images/wines/syrah/bottle-detail-0b1832459a4d3181c7f575d6134512cc.png";